var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "10"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [
                  _c("gg-select", {
                    attrs: {
                      outlined: "",
                      items: _vm.select.part,
                      "item-text": "title",
                      "item-value": "value"
                    },
                    on: {
                      change: _vm.changed
                    },
                    model: {
                      value: _vm.model.part,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "part", $$v)
                      },
                      expression: "model.part"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [
                  _c("gg-select", {
                    attrs: {
                      outlined: "",
                      items: _vm.select.match,
                      "item-text": "title",
                      "item-value": "value"
                    },
                    on: {
                      change: _vm.changed
                    },
                    model: {
                      value: _vm.model.match,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "match", $$v)
                      },
                      expression: "model.match"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [
                  _c("gg-select", {
                    attrs: {
                      outlined: "",
                      items: _vm.select.opt,
                      "item-text": "title",
                      "item-value": "value"
                    },
                    on: {
                      change: _vm.changed
                    },
                    model: {
                      value: _vm.model.opt,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "opt", $$v)
                      },
                      expression: "model.opt"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rules.filter_rule,
                        expression: "rules.filter_rule"
                      }
                    ],
                    attrs: {
                      label: "Enter a filter rule",
                      outlined: "",
                      "data-vv-name": "filter_rule",
                      "data-vv-as": "Filter rule",
                      "error-messages": _vm.errors.collect("filter_rule")
                    },
                    on: {
                      change: _vm.changed
                    },
                    model: {
                      value: _vm.model.val,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "val", $$v)
                      },
                      expression: "model.val"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "2"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "6"
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        left: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref) {
                            var on = _ref.on
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      elevation: "0",
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.sort("up")
                                      }
                                    }
                                  },
                                  on
                                ),
                                [_vm._v(" ▲ ")]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Move filter up")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        left: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref2) {
                            var on = _ref2.on
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      elevation: "0",
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.sort("down")
                                      }
                                    }
                                  },
                                  on
                                ),
                                [_vm._v(" ▼ ")]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Move filter down")])]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "6"
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        left: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref3) {
                            var on = _ref3.on
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      elevation: "0",
                                      text: ""
                                    },
                                    on: {
                                      click: _vm.addRuleItem
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-plus")])],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Add new filter")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        left: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref4) {
                            var on = _ref4.on
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      elevation: "0",
                                      text: ""
                                    },
                                    on: {
                                      click: _vm.removeRuleItem
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-minus")])],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [_c("span", [_vm._v("Delete filter")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }